import { defineMessage } from 'services/localization';

export const messages = {
    bubbleText: defineMessage('receive_from_dext_prepare'),
    submitterRequiredValidationText: defineMessage('please_select_a_requester'),
    learnMore: defineMessage('learn_more'),
    addRequester: defineMessage('add_a_requester'),
    emptyStepDescription: defineMessage('templatename_published__fter_the_final_approval'),
    stepDescription: defineMessage('all_templatename_receiv_r_the_name_of_this_user'),
    noSubmitterErrorText: defineMessage('specify_a_dext_submitter'),
    xeroCompany: defineMessage('xero_organisation'),
    qboCompany: defineMessage('quickbooks_online_company'),
};
